import styled from 'styled-components'

/**
 * @deprecated Use Divider from base-react-components instead
 */
export const Divider = styled.hr`
  border-radius: 4px;
  border: none;
  height: 4px;
  background-color: ${({ theme }) => theme.navNeutral200};
  margin: 0;
`
